import React, { useCallback, useMemo } from "react";

import { couponTableColumnsConfig } from "./couponTableColumnDef";
import { Table } from "../../../component/table/Table";

import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCouponFilter } from "../../../store/couponFilterSlice";
import {
  selectCoupons,
  useGetCouponsListQuery,
} from "../../../services/coupon/couponApiSlice";
import { CategoryPageSkeleton } from "../../../component/skeleton/CategoryPageSkeleton";

export const CouponTablePage = () => {
  const navigate = useNavigate();

  const { status, search } = useSelector(selectCouponFilter);

  // ✅ send BOTH search and status
  const { isSuccess, isLoading, isFetching } = useGetCouponsListQuery({
    search,
    status,
  });

  const tableData = useSelector(selectCoupons);

  const handleNavigateToDetail = useCallback(
    (cancellationId) => {
      navigate(`/coupons/${cancellationId}`);
    },
    [navigate],
  );

  const columnDefs = useMemo(
    () => couponTableColumnsConfig(handleNavigateToDetail),
    [handleNavigateToDetail],
  );
  return isSuccess ? (
    <Table
      data={tableData}
      columns={columnDefs}
      loading={isLoading || isFetching}
    />
  ) : (
    <CategoryPageSkeleton />
  );
};
